import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const BASKETBALL_IMG = 'https://static.prod-images.emergentagent.com/jobs/39f42643-5be0-4bf3-9009-a181262879ef/images/e60e8d9901179ba36f5f7c9cadbe55c31b9b09bef1b16815a4ff1b8931ba579d.jpeg';
const FITNESS_IMG = 'https://static.prod-images.emergentagent.com/jobs/39f42643-5be0-4bf3-9009-a181262879ef/images/dda64cc34e9b400f8d7c4224a0bc05b30e8ce8f1c246e4e02351cb39012d6eeb.jpeg';

const paths = [
  {
    id: 'basketball-card',
    title: 'Basketball',
    copy: 'For serious basketball players ready to reach the next level.',
    button: 'Explore Basketball',
    image: BASKETBALL_IMG,
    route: '/basketball',
    accent: 'silver',
    border: 'border-gray-500/40 hover:border-gray-300',
    bar: 'bg-gray-300',
    btn: 'bg-gray-300 hover:bg-white',
    glow: 'group-hover:shadow-[0_0_60px_-15px_rgba(255,255,255,0.35)]',
  },
  {
    id: 'fitness-card',
    title: 'Fitness',
    copy: 'Helping women 30+ get strong, lean & athletic again.',
    button: 'Explore Fitness',
    image: FITNESS_IMG,
    route: '/fitness',
    accent: 'silver',
    border: 'border-gray-500/40 hover:border-gray-300',
    bar: 'bg-gray-300',
    btn: 'bg-gray-300 hover:bg-white',
    glow: 'group-hover:shadow-[0_0_60px_-15px_rgba(255,255,255,0.35)]',
  },
];

export const PathSelector = () => {
  const navigate = useNavigate();
  return (
    <section id="paths" data-testid="path-selector" className="relative bg-black px-6 pt-8 pb-20 z-20">
      <div className="container mx-auto max-w-6xl grid md:grid-cols-2 gap-6 lg:gap-8">
        {paths.map((p, i) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            data-testid={p.id}
            className={`group relative rounded-2xl border ${p.border} bg-neutral-950 overflow-hidden transition-all duration-500 ${p.glow}`}
          >
            <div className="absolute inset-0">
              <img
                src={p.image}
                alt={p.title}
                className="w-full h-full object-cover opacity-60 transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/20" />
            </div>

            <div className="relative z-10 p-8 sm:p-10 min-h-[380px] flex flex-col justify-end">
              <h2 className="font-display text-white text-4xl sm:text-5xl uppercase">{p.title}</h2>
              <div className={`w-12 h-1 ${p.bar} mt-4 mb-5`} />
              <p className="text-gray-300 text-base leading-relaxed max-w-[260px] mb-8">{p.copy}</p>
              <button
                data-testid={`${p.id}-cta`}
                onClick={() => {
                  if (p.route) {
                    navigate(p.route);
                    return;
                  }
                  const el = document.getElementById('coach');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`inline-flex items-center gap-2 ${p.btn} text-black font-bold px-6 py-3 rounded-lg w-fit transition-all duration-300 group/btn`}
              >
                {p.button}
                <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
